<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div
      class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25"
    >
      <div class="container-fluid">
        <div class="row align-items-center mb-2">
          <!-- Per page selector and total -->
          <div class="col-md-4 d-flex align-items-center mb-2 mb-md-0">
            <label class="me-2">Voir</label>
            <v-select
              v-model="filters.per_page"
              :options="[10, 25, 50, 100]"
              :clearable="false"
              class="per-page-selector d-inline-block mx-2"
              @update:modelValue="getRecords()"
              style="width: 80px"
            />
            <label class="ms-2">sur {{ filters.total }} entités</label>
          </div>
          <!-- Admin: create BL -->
          <div class="col-md-8 d-flex justify-content-end mb-2 mb-md-0">
            <button
              v-if="auth.can('BL')"
              class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block"
              type="button"
              @click="openCreateBLModal"
            >
              Nouveau BL
              <i class="flaticon-plus position-relative ms-5 fs-12"></i>
            </button>
          </div>
        </div>
        <div class="row align-items-end">
          <div class="col-md-3 mb-2">
            <!-- <label>Chercher</label> -->
            <input
              type="text"
              class="form-control shadow-none text-black rounded-0"
              placeholder="Chercher"
              @change="filter()"
              @input="handleInput"
              v-model="filters.searchTerm"
            />
          </div>

          <!-- Customer -->
          <div class="col-md-4 mb-2">
            <label>Magasin</label>
            <v-select
              v-model="client_filter"
              label="name"
              :options="clientList"
            />
            <!-- @search="filterClients" -->
          </div>
          <!-- Status -->
          <div class="col-md-2 mb-2">
            <label>Status</label>
            <select
              v-model="status_filter"
              class="form-control"
              style="min-width: 140px"
            >
              <option value="">Status (Tous)</option>
              <option :value="0">Nouveau</option>
              <option :value="1">Enregistré</option>
            </select>
          </div>
          <!-- Filter/Reset buttons -->
          <div class="col-md-3 mb-2 d-flex gap-1">
            <button class="btn btn-primary" @click="filter">
              <i class="flaticon-filter"></i>
              Filtrer
            </button>
            <button class="btn btn-outline-secondary" @click="removeFilter">
              <i class="flaticon-refresh"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <vue-good-table :columns="columns" :rows="rows" :loading="isLoader">
        <template #emptystate>
          <center>Aucune entrées correspondantes trouvées</center>
        </template>

        <template #table-row="props">
          <template v-if="props.column.field === 'note_ref'">
            <b>{{ props.row.note_ref }}</b>
          </template>
          <template v-else-if="props.column.field === 'note_customer_name'">
            <div class="text-nowrap">
              <template v-if="props.row.client && props.row.client.store">
                {{ props.row.client.store }}
              </template>
              <template v-else>{{
                props.row.client.note_customer_name
              }}</template>
            </div>
          </template>

          <template v-else-if="props.column.field === 'created_at'">
            {{ getDate(props.row.created_at) }}
          </template>

          <template v-else-if="props.column.field === 'note_total_parcel'">
            {{ props.row.note_total_parcel }} Colis
          </template>
          <template v-else-if="props.column.field === 'note_total_crbt'">
            {{ props.row.crbt }} {{ $devis }}
          </template>

          <template v-else-if="props.column.field === 'crbt'">
            {{ props.row.crbt }} {{ $devis }}
          </template>

          <template v-else-if="props.column.field === 'note_saved'">
            <span
              v-if="props.row.note_saved == 0"
              :class="`badge rounded-pill fs-13 text-bg-${resolveUserStatusVariant(
                props.row.note_saved
              )}`"
              class="text-capitalize"
            >
              Nouveau
            </span>
            <span
              v-else-if="props.row.note_saved == 1"
              :class="`badge rounded-pill fs-13 text-bg-${resolveUserStatusVariant(
                props.row.note_saved
              )}`"
              class="text-capitalize"
            >
              Enregistré
            </span>
          </template>
          <template v-else-if="props.column.field === 'action'">
            <div class="dropdown">
              <button
                class="dropdown-toggle card-dot-btn lh-1 position-relative top-4 bg-transparent border-0 shadow-none p-0 transition"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i class="flaticon-dots"></i>
              </button>
              <ul class="dropdown-menu">
                <li v-if="auth.can('BL')">
                  <a
                    class="dropdown-item d-flex align-items-center"
                    href="javascript:void(0);"
                    @click="showDetailSuivi(props.row)"
                  >
                    <i
                      class="flaticon-view lh-1 me-8 position-relative top-1"
                    ></i>
                    Détails
                  </a>
                </li>
                <li v-if="auth.can('BL') && props.row.note_saved == 0">
                  <router-link
                    class="dropdown-item d-flex align-items-center"
                    :to="{ name: 'AdminEditDeliveryNote', params: { id: props.row.id, refNote: props.row.note_ref } }"
                  >
                    <i
                      class="flaticon-edit lh-1 me-8 position-relative top-1"
                    ></i>
                    Modifier
                  </router-link>
                </li>
                <li v-if="auth.can('BL') && props.row.note_total_parcel == 0">
                  <a
                    class="dropdown-item d-flex align-items-center"
                    href="javascript:void(0);"
                    @click="removeBL(props.row.id)"
                  >
                    <i
                      class="flaticon-delete lh-1 me-8 position-relative top-1"
                    ></i>
                    Supprimer
                  </a>
                </li>
                <li
                  v-if="
                    auth.can('BL') &&
                    props.row.note_saved == 0 &&
                    props.row.note_total_parcel != 0
                  "
                >
                  <a
                    class="dropdown-item d-flex align-items-center"
                    href="javascript:void(0);"
                    @click="saveBL(props.row.id)"
                  >
                    <i
                      class="flaticon-diskette lh-1 me-8 position-relative top-1"
                    ></i>
                    Enregistrer
                  </a>
                </li>

                <li>
                  <a
                    v-if="auth.can('BL') && props.row.note_total_parcel != 0"
                    class="dropdown-item d-flex align-items-center"
                    href="javascript:void(0);"
                    @click="getPDF(props.row)"
                  >
                    <i
                      class="flaticon-printer lh-1 me-8 position-relative top-1"
                    ></i>
                    PDF
                  </a>
                </li>

                <li>
                  <a
                    v-if="auth.can('BL') && props.row.note_total_parcel != 0"
                    class="dropdown-item d-flex align-items-center"
                    href="javascript:void(0);"
                    @click="ticketsPDF(props.row)"
                  >
                    <i
                      class="flaticon-menu lh-1 me-8 position-relative top-1"
                    ></i>
                    Tickets
                  </a>
                </li>

                <li>
                  <a
                    v-if="auth.can('BL') && props.row.note_total_parcel != 0"
                    class="dropdown-item d-flex align-items-center"
                    href="javascript:void(0);"
                    @click="tickets4PDF(props.row)"
                  >
                    <i
                      class="flaticon-more-1 lh-1 me-8 position-relative top-1"
                    ></i>
                    Tickets 4*4
                  </a>
                </li>
              </ul>
            </div>
          </template>

          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>
      </vue-good-table>
      <PaginatorContent
        :pagination="filters"
        :offset="9"
        @paginate="getRecords"
      />
    </div>
  </div>

  <!-- Create BL Modal (Admin) -->
  <div class="modal fade" id="createBLModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-md">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title fw-semibold">
            <i class="flaticon-plus me-8 fs-14"></i>
            Nouveau Bon de Livraison
          </h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body p-25">
          <div class="mb-20">
            <label class="form-label fw-semibold mb-8">
              Client / Magasin <span class="text-danger">*</span>
            </label>
            <v-select
              v-model="newBLClient"
              label="name"
              :options="blClientList"
              :loading="blClientLoading"
              :filterable="false"
              placeholder="Rechercher un client..."
              :clearable="false"
              @search="onBLClientSearch"
              @open="loadBLClients('')"
            >
              <template #option="option">
                <div class="d-flex justify-content-between align-items-center">
                  <div>
                    <span class="fw-semibold">{{ option.name }}</span>
                    <span v-if="option.store" class="text-muted ms-6 small">{{ option.store }}</span>
                  </div>
                  <span class="badge bg-primary ms-10">{{ option.colis_count }} colis</span>
                </div>
              </template>
              <template #selected-option="option">
                {{ option.name }}<span v-if="option.store" class="text-muted ms-6">— {{ option.store }}</span>
              </template>
              <template #no-options="{ search }">
                <span v-if="blClientLoading">Chargement...</span>
                <span v-else-if="search">Aucun client trouvé pour "{{ search }}"</span>
                <span v-else>Aucun client avec des colis disponibles</span>
              </template>
            </v-select>
            <div v-if="createBLError" class="text-danger small mt-8">
              Veuillez sélectionner un client.
            </div>
          </div>
        </div>
        <div class="modal-footer border-0 pt-0">
          <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">
            Annuler
          </button>
          <button
            type="button"
            class="btn btn-success"
            :disabled="createBLLoading"
            @click="createAdminBL"
          >
            <span v-if="createBLLoading" class="spinner-border spinner-border-sm me-6" role="status"></span>
            {{ createBLLoading ? "Création..." : "Créer le BL" }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" id="detailBonModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-xl">
      <div class="modal-content p-15 p-md-40">
        <div class="modal-header">
          <h1 class="modal-title fs-5">Informations colis</h1>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>

        <div class="modal-body">
          <DetailsNote
            v-if="noteBL && Object.keys(noteBL).length > 0"
            :key="noteBL.id"
            :noteBL="noteBL"
            :getRecords="getRecords"
            :type="true"
            :isOpen="isOpen"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script  lang="ts">
import { onMounted, reactive, ref } from "vue";
import flatpickr from "flatpickr";
import { useAppToast } from "@/composables/useAppToast";
import api from "@/utils/axios";
import moment from "moment";
import { useAuthStore } from "@/stores/auth";
import Swal from "sweetalert2";
import DetailsNote from "./DetailsNote.vue";
import { Modal } from "bootstrap";
import { useRouter } from "vue-router";

export default {
  name: "ListeNotes",
  components: { DetailsNote },
  setup: () => {
    const { showToast } = useAppToast();
    const auth = useAuthStore();
    const user = auth.user;
    const router = useRouter();

    interface Status {
      code: string;
      name: string;
      code_color?: string;
    }

    const rows = ref([]);
    const isLoader = ref(false);
    const noteBL = ref(null);

    const statusList = ref<Status[]>([]);

    const clientList = ref<Status[]>([]);
    const client_filter = ref({ id: "", name: "" });
    const status_filter = ref("");
    const columns = [
      {
        label: "Référence",
        field: "note_ref",
      },
      {
        label: "Store",
        field: "note_customer_name",
      },
      {
        label: "Date de création",
        field: "created_at",
        width: "180px",
      },
      {
        label: "Statut",
        field: "note_saved",
      },
      {
        label: "Colis",
        field: "note_total_parcel",
      },
      {
        label: "Total",
        field: "crbt",
      },
      {
        label: "Action",
        field: "action",
      },
    ];
    const filters = reactive({
      searchName: "",
      searchTerm: "",
      searchCustomer: "",
      searchStatut: "",
      searchDateType: "",
      searchSDate: "",
      searchEDate: "",
      searchStore: "",
      total: 0,
      per_page: 10,
      from: 1,
      to: 0,
      current_page: 1,
    });

    onMounted(async () => {
      getRecords();
      try {
        const res = await api.get(`/api/auth/CustsFilter`);
        clientList.value = res.data;
        clientList.value.unshift({ code: "0", name: "Tous" });
      } catch (error) {
        console.error("Error fetching clients:", error);
        clientList.value = [];
      }
    });
    async function getRecords(page = 1) {
      filters.current_page = page;
      isLoader.value = true;
      try {
        const response = await api.get(
          `/api/auth/delivery_note_list?searchCustomer=${filters.searchCustomer}&searchStore=${filters.searchStore}&searchStatut=${filters.searchStatut}&searchSDate=${filters.searchSDate}&searchEDate=${filters.searchEDate}&searchTerm=${filters.searchTerm}&page=${filters.current_page}&per_page=${filters.per_page}`
        );

        rows.value = response.data.users.data;
        Object.assign(filters, response.data.users);
      } catch (error) {
        console.error("Erreur lors du chargement des enregistrements:", error);
      } finally {
        isLoader.value = false;
      }
    }

    function getDate(value) {
      return moment(String(value)).format("YYYY-MM-DD HH:mm");
    }
    function resolveUserStatusVariant(status) {
      if (status == 0) return "warning";
      if (status == 1) return "info";
      return "danger";
    }

    let debounceTimeout: number | undefined;

    async function filterClients(search: string, loading: { value: boolean }) {
      const query = search.trim().toLowerCase();

      if (!query) {
        clientList.value = [];
        return;
      }

      // Debounce to avoid too many API calls
      if (debounceTimeout) clearTimeout(debounceTimeout);

      debounceTimeout = window.setTimeout(async () => {
        try {
          const res = await api.get(`/api/auth/ListCustsFilter`, {
            params: { query },
          });
          clientList.value = res.data;
          clientList.value.unshift({ code: "0", name: "Tous" });
        } catch (error) {
          console.error("Error fetching clients:", error);
          clientList.value = [];
        }
      }, 300); // 300ms debounce
    }

    function filter() {
      filters.searchCustomer = client_filter.value.id;
      filters.searchStatut = status_filter.value;
      //   filters.searchStore = this.store_filter.id
      //   filters.searchSDate = (this.$refs.myInput.dateRange.start == undefined || this.$refs.myInput.dateRange.start == 'undefined') ? '' : this.convert(this.$refs.myInput.dateRange.start)
      //   filters.searchEDate = (this.$refs.myInput.dateRange.end == undefined || this.$refs.myInput.dateRange.end == 'undefined') ? '' : this.convert(this.$refs.myInput.dateRange.end)
      filters.current_page = 1;
      getRecords();
    }
    function convert(str) {
      const date = new Date(str);
      const mnth = `0${date.getMonth() + 1}`.slice(-2);
      const day = `0${date.getDate()}`.slice(-2);
      return [date.getFullYear(), mnth, day].join("-");
    }
    function removeFilter() {
      filters.searchCustomer = filters.searchStatut = filters.searchStore = "";
      filters.searchSDate = filters.searchEDate = filters.searchDateType = "";
      client_filter.value = { id: "", name: "" };
      status_filter.value = "";
      filters.searchTerm = this.searchTerm = "";
      //   this.$refs.myInput.dateRange = {}
      filters.current_page = 1;
      getRecords();
    }
    function handleInput() {
      //   // Clear previous debounce timer
      //   clearTimeout(this.debounceTimer);

      //   // Set a new debounce timer
      //   this.debounceTimer = setTimeout(() => {
      //     if (!this.searchTerm || this.searchTerm === '') {
      //     filters.searchTerm = this.searchTerm
      //     this.filter()
      //   } else if (this.searchTerm && this.searchTerm.length > 4) {
      //     filters.searchTerm = this.searchTerm
      //     this.filter()
      //   }
      //   }, 500); // Adjust the delay (in milliseconds) as needed
      filter();
    }

    async function removeBL(id) {
      const data = new FormData();
      data.append("bl_id", id);

      const result = await Swal.fire({
        text: "Vous voulez supprimer ce bon de livraison ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Oui, supprimer!",
      });

      if (result.isConfirmed) {
        try {
          const res = await api.post(`/api/auth/DeleteBL`, data);

          if (res.data.message === "success") {
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Le bon de livraison est bien supprimé",
              showConfirmButton: false,
              timer: 1500,
            });

            getRecords(); // 🔹 if you are using Composition API. If still in Options API, keep `this.getRecords()`.
          } else if (res.data.message === "Issaved") {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Vous pouvez pas le supprimer!",
            });
          }
        } catch (error) {
          console.error("Erreur suppression BL:", error);
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong! Veuillez réessayer",
          });
        }
      }
    }

    async function saveBL(id) {
      try {
        const res = await api.post(`/api/auth/SaveBL/${id}`);

        if (res.data.message === "success") {
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Le bon de livraison est bien enregistré",
            showConfirmButton: false,
            timer: 1500,
          });

          getRecords(); // 🔹 if Composition API. Use `this.getRecords()` if Options API.
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Erreur, merci de réessayer encore!",
          });
        }
      } catch (error) {
        console.error("Erreur API SaveBL:", error);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong! Veuillez réessayer",
        });
      }
    }

    async function getPDF(row) {
      try {
        const response = await api.get(`/api/auth/DELPDF/${row.id}`, {
          responseType: "arraybuffer",
        });

        const blob = new Blob([response.data], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);

        window.open(url, "_blank");
      } catch (error) {
        console.error("Erreur génération PDF:", error);
        showToast("erreur lors la génération du PDF (tickets)", "error");
      }
    }

    async function ticketsPDF(row) {
      try {
        const response = await api.get(`/api/auth/TicketsPDF/${row.id}`, {
          responseType: "arraybuffer",
        });

        const blob = new Blob([response.data], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);

        window.open(url, "_blank");
      } catch (error) {
        console.error("Erreur génération TicketsPDF:", error);
        showToast("erreur lors la génération du PDF (tickets)", "error");
      }
    }

    async function tickets4PDF(row) {
      try {
        const response = await api.get(`/api/auth/Tickets4PDF/${row.id}`, {
          responseType: "arraybuffer",
        });

        const blob = new Blob([response.data], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);

        window.open(url, "_blank");
      } catch (error) {
        console.error("Erreur génération Tickets4PDF:", error);
        showToast("erreur lors la génération du PDF (tickets)", "error");
      }
    }
    const isOpen = ref(false);

    // Admin: create BL
    const newBLClient = ref<any>(null);
    const createBLLoading = ref(false);
    const createBLError = ref(false);
    const blClientList = ref<any[]>([]);
    const blClientLoading = ref(false);
    let createBLModalInstance: any = null;
    let blClientDebounce: ReturnType<typeof setTimeout> | null = null;

    async function loadBLClients(search = "") {
      blClientLoading.value = true;
      try {
        const res = await api.get("/api/auth/admin_ClientsColisCount", {
          params: { searchTerm: search, per_page: 15 },
        });
        blClientList.value = res.data?.data?.data ?? [];
      } catch (e) {
        console.error(e);
        blClientList.value = [];
      } finally {
        blClientLoading.value = false;
      }
    }

    function onBLClientSearch(search: string) {
      if (blClientDebounce) clearTimeout(blClientDebounce);
      blClientDebounce = setTimeout(() => loadBLClients(search), 300);
    }

    function openCreateBLModal() {
      newBLClient.value = null;
      createBLError.value = false;
      blClientList.value = [];
      const modalEl = document.getElementById("createBLModal");
      if (modalEl) {
        createBLModalInstance = new Modal(modalEl);
        createBLModalInstance.show();
      }
    }

    async function createAdminBL() {
      if (!newBLClient.value || !newBLClient.value.id) {
        createBLError.value = true;
        return;
      }
      createBLError.value = false;
      createBLLoading.value = true;
      try {
        const res = await api.post("/api/auth/admin_Add_BL", {
          client_id: newBLClient.value.id,
        });

        if (res.data?.note) {
          createBLModalInstance?.hide();
          showToast("Bon de livraison créé avec succès", "success");
          router.push({
            name: "AdminEditDeliveryNote",
            params: { id: res.data.note.id, refNote: res.data.note.note_ref },
          });
        } else {
          showToast(res.data?.message || "Erreur lors de la création du BL", "error");
        }
      } catch (error) {
        console.error(error);
        showToast("Une erreur est survenue, veuillez réessayer", "error");
      } finally {
        createBLLoading.value = false;
      }
    }

    function showDetailSuivi(row) {
      noteBL.value = {};
      // noteBmBL=[];
      noteBL.value = row;

      const modalEl = document.getElementById("detailBonModal");
      if (modalEl) {
        isOpen.value = true;
        const modal = new Modal(modalEl);
        modal.show();
      }
    }

    return {
      auth,
      rows,
      isLoader,
      columns,
      filters,
      getRecords,
      getDate,
      resolveUserStatusVariant,
      filter,
      convert,
      removeFilter,
      handleInput,

      showDetailSuivi,
      removeBL,
      saveBL,
      getPDF,
      ticketsPDF,
      tickets4PDF,
      noteBL,
      isOpen,

      clientList,
      status_filter,
      client_filter,
      statusList,
      filterClients,

      newBLClient,
      blClientList,
      blClientLoading,
      onBLClientSearch,
      loadBLClients,
      createBLLoading,
      createBLError,
      openCreateBLModal,
      createAdminBL,
    };
  },
};
</script>